import { useMemo } from 'react';
import { filter, isEmpty, map } from 'lodash';
import { IdCardProvider } from '../../screens/HomeScreen/context/idCard';
import IdCardCompareMode from '../IdCardCompareMode';
import IdCard from '../IdCard';
import SideMenuSearchLane from '../SideMenuSearchLane';
import { useIdCatalogSearch } from '../SideMenuSearchLane/context';
import { LeftPanel, MenuIconBtn, RightPanel, Container, CollapseToggleContainer, SlotsContainer, Slot } from './styles';
import { useStandardization } from '../../screens/StandardizationScreen/context';
import CreateEditModuleModal from '../StandardizationProject/CreateEditModuleModal';
import useCreateEditModuleModal from '../../hooks/useCreateEditModuleModal';
import { useUser } from '../../context/user';
import { user_roles } from "../../config/enums";

const getActiveSlots = (slots) =>
  map(
    filter(slots, (itemData) => itemData && (itemData.idCard || itemData.isLoading || itemData.error)),
    (item) => ({ idCard: item.idCard, isLoading: item.isLoading, error: item.error })
  );

const CatalogSlideContainerComponent = () => {
  const { user } = useUser();
  const canEdit = user?.roles.includes(user_roles.catalogAdmin) ||
      user?.roles.includes(user_roles.catalogProjectAdmin) ||
      user?.roles.includes(user_roles.catalogProjectEditor) ||
      user?.roles.includes(user_roles.admin) ||
      user?.roles.includes(user_roles.castAdmin);
  const { firstSlotCatalogItem, sideMenuZIndex, secondSlotCatalogItem, setIsSideMenuCollapsed, isSideMenuCollapsed } =
    useIdCatalogSearch();

  const catalogItemSlots = useMemo(
    () => getActiveSlots([firstSlotCatalogItem, secondSlotCatalogItem]),
    [(firstSlotCatalogItem, secondSlotCatalogItem)]
  );

  const shouldRenderRightPanel = !isSideMenuCollapsed && !isEmpty(catalogItemSlots);
  const shouldRenderIdCardViewMode = catalogItemSlots && catalogItemSlots.length == 1;
  const shouldRenderIdCardsInComparisonMode = catalogItemSlots && catalogItemSlots.length > 1;

  const { standardizationProject } = useStandardization();

  const { moduleModal, onAddModule, onModuleModalClose, referenceModule, onAddModuleClick, setReferenceModule } =
    useCreateEditModuleModal({ standardizationProject });

  return (
    <IdCardProvider>
      <Container
        isCollapsed={isSideMenuCollapsed}
        zIndex={sideMenuZIndex}>
        <LeftPanel>
          <SideMenuSearchLane isCollapsed={isSideMenuCollapsed} />
        </LeftPanel>
        {shouldRenderRightPanel && (
          <RightPanel>
            <SlotsContainer>
              {shouldRenderIdCardViewMode && (
                <IdCard
                 itemData={catalogItemSlots[0]}
                 onAddToLayoutClick={onAddModuleClick}
                />
              )}
              {shouldRenderIdCardsInComparisonMode &&
                catalogItemSlots.map((itemData, nth) => (
                  <Slot key={nth}>
                    <IdCardCompareMode
                      onAddToLayoutClick={onAddModuleClick}
                      itemData={itemData}
                      canRenderComparisonCuts={nth === 0}
                    />
                  </Slot>
                ))}
            </SlotsContainer>
          </RightPanel>
        )}

        <CollapseToggleContainer onClick={() => setIsSideMenuCollapsed((current) => !current)}>
          <MenuIconBtn />
          <label>Catalog</label>
        </CollapseToggleContainer>
      </Container>
      {moduleModal.isOpen && (
        <CreateEditModuleModal
          module={moduleModal.module}
          defaultFields={moduleModal.defaultFields}
          onModalClose={onModuleModalClose}
          onAddModule={onAddModule}
          isMenuOpen={false}
          // setIsMenuOpen={setIsMenuOpen}
          referenceModule={referenceModule}
          setReferenceModule={setReferenceModule}
          // onUpdateModule={onUpdateModuleInCreateEditModal}
          // onRemoveModule={onRemoveModule}
          isAdmin={canEdit}
          // projectPhase={editableProject.phase}
          onModuleRecommendationClick={onAddModuleClick}
        />
      )}
    </IdCardProvider>
  );
};

export default CatalogSlideContainerComponent;
